var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#0A0A0A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "row2_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x36__3_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transparent"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.7,0.3,0,28.8,0,64c0,35.2,28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7C128,28.8,99.3,0.3,64,0.3z  M64,121.3C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c12.1,0,23.4,3.7,32.7,10.1c13.7,9.4,23.1,24.5,24.7,41.8 c0,0.5,0.1,9.8,0,10.7C118.7,98.5,94,121.3,64,121.3z M60.8,32.2c-14.5,0-19.1,13.3-19.2,25.5h9.6c-0.2-8.8,0.7-15.9,9.6-15.9 c6.4,0,9.6,2.7,9.6,9.6c0,4.4-3.4,6.6-6.4,9.6c-6.2,6-5.7,10.4-6,18.7h8.4c0.3-7.5,0.2-7.3,6.4-13.9c4.2-4.1,7.1-8.2,7.1-14.5 C80,41.2,74.6,32.2,60.8,32.2z M64.1,86.3c-3.6,0-6.4,2.9-6.4,6.4c0,3.5,2.9,6.4,6.4,6.4c3.6,0,6.4-2.9,6.4-6.4 C70.5,89.1,67.6,86.3,64.1,86.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x35__3_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "down_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.7,0.3,0,28.8,0,64s28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7S99.3,0.3,64,0.3z M64,121.3 C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c31.8,0,57.6,25.7,57.6,57.3C121.6,95.7,95.8,121.3,64,121.3z M85.7,58.1 L70.4,70.3V41.7c0-2.2-2.3-3.2-4.4-3.2H62c-2.2,0-3.9,1.8-3.9,3.9v28.4L42.3,58.1c-2.2,0-3.9,1.8-3.9,3.9v7.1L64,95.8l25.6-26.7 V62C89.6,59.8,87.8,58.1,85.7,58.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x34__3_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "up"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.7,0.3,0,28.8,0,64s28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7S99.3,0.3,64,0.3z M64,121.3 C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c31.8,0,57.6,25.7,57.6,57.3C121.6,95.7,95.8,121.3,64,121.3z M38.4,58.9 V66c0,2.2,1.8,3.9,3.9,3.9l15.3-12.2v28.7c0,2.2,2.3,3.2,4.4,3.2H66c2.2,0,3.9-1.8,3.9-3.9V57.2l15.8,12.7 c2.2,0,3.9-1.8,3.9-3.9v-7.1L64,32.2L38.4,58.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x33__3_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.8,0.3,0.3,28.8,0.3,64c0,35.2,28.5,63.7,63.7,63.7c35.2,0,63.7-28.5,63.7-63.7 C127.7,28.8,99.2,0.3,64,0.3z M64,121.3C32.3,121.3,6.7,95.7,6.7,64C6.7,32.3,32.3,6.7,64,6.7c31.7,0,57.3,25.7,57.3,57.3 C121.3,95.7,95.7,121.3,64,121.3z M62,38.5c-2.2,0-3.9,1.8-3.9,3.9l12.2,15.2H41.7c-2.2,0-3.2,2.2-3.2,4.4V66 c0,2.2,1.8,3.9,3.9,3.9h28.4L58.1,85.6c0,2.2,1.8,3.9,3.9,3.9h7.1L95.8,64L69.1,38.5H62z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x32__4_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.7,0.3,0,28.8,0,64c0,35.2,28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7C128,28.8,99.3,0.3,64,0.3z  M64,121.3C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c31.8,0,57.6,25.7,57.6,57.3C121.6,95.7,95.8,121.3,64,121.3z  M86.4,57.6H57.6l12.3-15.2c0-2.2-1.8-3.9-3.9-3.9h-7.1L32,64l26.8,25.5H66c2.2,0,3.9-1.8,3.9-3.9L57.1,69.9h28.6 c2.2,0,3.9-1.8,3.9-3.9V62C89.6,59.9,88.6,57.6,86.4,57.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x31__4_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.7,0.3,0,28.8,0,64c0,35.2,28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7C128,28.8,99.3,0.3,64,0.3z  M64,121.3C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c31.8,0,57.6,25.7,57.6,57.3C121.6,95.7,95.8,121.3,64,121.3z  M65.3,38.5L41.6,64l23.6,25.5h13.5L54.4,64l24.4-25.5H65.3z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "row1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x36__2_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_transparent",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.7,0.3,0,28.8,0,64c0,35.2,28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7C128,28.8,99.3,0.3,64,0.3z  M64,121.3C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c31.8,0,57.6,25.7,57.6,57.3C121.6,95.7,95.8,121.3,64,121.3z  M84.8,60.8H70.4V46.5c0-2.6-2.2-4.8-4.8-4.8c-2.7,0-4.8,2.1-4.8,4.8v14.3H46.4c-2.7,0-4.8,2.1-4.8,4.8c0,2.6,2.1,4.8,4.8,4.8 h14.4v14.3c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8V70.4h14.4c2.6,0,4.8-2.1,4.8-4.8C89.6,63,87.5,60.8,84.8,60.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x35__2_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error_transparent_copy",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.7,0.3,0,28.8,0,64c0,35.2,28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7C128,28.8,99.3,0.3,64,0.3z  M64,121.3C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c31.8,0,57.6,25.7,57.6,57.3C121.6,95.7,95.8,121.3,64,121.3z  M87.2,44.5c-0.9-0.9-2.3-0.9-3.2,0L55.2,73.2L41.4,59.5c-0.9-0.9-2.3-0.9-3.2,0l-4.8,4.8c-0.9,0.9-0.9,2.3,0,3.2l15.3,15.3 c0,0,0,0,0,0l3.3,3.3l0.8,0.8l0,0l0.7,0.7c0.9,0.9,2.3,0.9,3.2,0L92,52.5c0.9-0.9,0.9-2.3,0-3.2L87.2,44.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x34__2_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error_transparent",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.7,0.3,0,28.8,0,64c0,35.2,28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7C128,28.8,99.3,0.3,64,0.3z  M64,121.3C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c31.8,0,57.6,25.7,57.6,57.3C121.6,95.7,95.8,121.3,64,121.3z  M85.9,48.1L81,43.3c-0.9-0.9-2.3-0.9-3.2,0L64,57L50.2,43.3c-0.9-0.9-2.3-0.9-3.2,0l-4.9,4.8c-0.9,0.9-0.9,2.3,0,3.2L55.9,65 L42.1,78.8c-0.9,0.9-0.9,2.3,0,3.2l4.9,4.8c0.9,0.9,2.3,0.9,3.2,0L64,73.1l13.8,13.7c0.9,0.9,2.3,0.9,3.2,0l4.9-4.8 c0.9-0.9,0.9-2.3,0-3.2L72.1,65l13.8-13.7C86.8,50.4,86.8,49,85.9,48.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x33__2_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert_transparent",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,32.2c-4.4,0-8,3.3-8,7.3v24.8c0,4.1,3.6,7.3,8,7.3s8-3.3,8-7.3V39.5C72,35.4,68.4,32.2,64,32.2z  M64,0.3C28.7,0.3,0,28.8,0,64c0,35.2,28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7C128,28.8,99.3,0.3,64,0.3z M64,121.3 C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c31.8,0,57.6,25.7,57.6,57.3C121.6,95.7,95.8,121.3,64,121.3z M64,81.2 c-4.4,0-8,3.3-8,7.3s3.6,7.3,8,7.3s8-3.3,8-7.3S68.4,81.2,64,81.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x32__3_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus_transparent",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0.3C28.7,0.3,0,28.8,0,64c0,35.2,28.7,63.7,64,63.7c35.3,0,64-28.5,64-63.7C128,28.8,99.3,0.3,64,0.3z  M64,121.3C32.2,121.3,6.4,95.7,6.4,64C6.4,32.3,32.2,6.7,64,6.7c31.8,0,57.6,25.7,57.6,57.3C121.6,95.7,95.8,121.3,64,121.3z  M81.6,60.8H43.2c-2.7,0-4.8,2.1-4.8,4.8c0,2.6,2.2,4.8,4.8,4.8h38.4c2.6,0,4.8-2.1,4.8-4.8C86.4,63,84.3,60.8,81.6,60.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x31__3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32__2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,0C28.7,0,0,28.7,0,64s28.7,64,64,64c35.3,0,64-28.7,64-64S99.3,0,64,0z M64,121.6 C32.2,121.6,6.4,95.8,6.4,64S32.2,6.4,64,6.4c31.8,0,57.6,25.8,57.6,57.6S95.8,121.6,64,121.6z M49.2,38.4L73.6,64L49.2,89.6 h13.5L86.4,64L62.7,38.4H49.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.264804b1f9393c8d3afb692a92949914.svg";
export { ForwardRef as ReactComponent };